export const GET_CLUSTER_KEYWORDS = 'GET_CLUSTER_KEYWORDS';
export const SET_CLUSTER_KEYWORDS = 'SET_CLUSTER_KEYWORDS';
export const ERROR_CLUSTER_KEYWORDS = 'ERROR_CLUSTER_KEYWORDS';

export const GET_CLUSTER_TILES = 'GET_CLUSTER_TILES';
export const SET_CLUSTER_TILES = 'SET_CLUSTER_TILES';
export const ERROR_CLUSTER_TILES = 'ERROR_CLUSTER_TILES';